import BaseModelInstance from './base.model'
import { UserMeta as ModelDefinition } from './model-definitions'

class UserMeta extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserMeta
